import type { FC } from 'react';
import { Box, Flex, Skeleton } from '@chakra-ui/react';
import type { SkeletonProps } from '@chakra-ui/react';

export const AccountOneColumnSkeleton: FC<SkeletonProps> = (props) => (
    <div className="flex items-center justify-center" data-testid="account-one-column-skeleton">
        <Flex
            width={{
                base: '100vw',
                md: '712px',
            }}
            gap={4}
            direction="column"
            justifyContent="center"
            alignItems="center"
            my={8}
        >
            <Box
                px={{
                    base: 4,
                    sm: 8,
                    md: 0,
                }}
                width="100%"
            >
                <Skeleton
                    {...props}
                    height={{
                        base: '96px',
                        sm: '48px',
                    }}
                    rounded="none"
                />
            </Box>
            <Skeleton
                {...props}
                height={{
                    base: '544px',
                    sm: '504px',
                    md: '406px',
                    xl: '504px',
                }}
                width="100%"
                rounded="none"
            />
        </Flex>
    </div>
);
